<div class="p-4 d-flex flex-column align-items-center justify-content-center">
  <img
    src="./assets/images/sad.svg"
    alt="Not Found"
    height="82px"
    width="82px"
  />
  <p class="text-cfSecondary fw-bold">{{ message() }}</p>
</div>
